module.exports = __webpack_public_path__ + "static/media/btl-atl.bc844a75.svg";